import { Controller } from "react-hook-form";
import { Col, Form, Input, Modal, Typography } from "antd";
import { KeyOutlined, LockOutlined } from "@ant-design/icons";

import useUpdatePasswordFormModal from "./useUpdatePasswordFormModal";

const { Text } = Typography;

interface IProps {
    userId: number;
    onClose: () => void;
    onFormSubmited: () => void;
}

export default function UpdatePasswordFormModal({ userId, onClose, onFormSubmited }: IProps) {
    const {
        isSubmiting,
        handleSubmit,
        handleSubmitForm,
        handleConfirmUpdatePassword,
        control,
        errors,
        refForm,
    } = useUpdatePasswordFormModal(onFormSubmited, userId);

    return (
        <Modal
            open
            title={
                <div style={{ display: "flex", alignItems: "center", gap: 8 }}>
                    <KeyOutlined style={{ color: "#faad14", fontSize: 18 }} />
                    <span>Redefinir Senha de Acesso</span>
                </div>
            }
            cancelText="Cancelar"
            okText="Salvar Nova Senha"
            onCancel={onClose}
            onOk={handleConfirmUpdatePassword}
            centered
            okButtonProps={{
                disabled: isSubmiting,
                loading: isSubmiting,
                style: { fontWeight: 600 },
            }}
            cancelButtonProps={{
                disabled: isSubmiting,
            }}
        >
            <Text type="secondary" style={{ display: "block", marginBottom: 16, fontSize: 12.5 }}>
                Digite a nova senha de acesso para este usuário. A senha deve possuir no mínimo 8 caracteres.
            </Text>

            <Form
                layout="vertical"
                onFinish={handleSubmit(handleSubmitForm)}
                ref={refForm}
            >
                <Col xs={24}>
                    <Form.Item
                        label={<strong>Nova Senha</strong>}
                        required
                        validateStatus={errors.password ? "error" : undefined}
                        help={errors.password?.message}
                    >
                        <Controller
                            name="password"
                            control={control}
                            rules={{
                                required: "Por favor, digite a nova senha!",
                                minLength: {
                                    value: 8,
                                    message: "A senha precisa ter no mínimo 8 caracteres!",
                                },
                            }}
                            render={({ field }) => (
                                <Input.Password
                                    {...field}
                                    placeholder="Digite a nova senha (mínimo 8 dígitos)"
                                    prefix={<LockOutlined style={{ color: "#faad14" }} />}
                                    size="large"
                                    style={{ borderRadius: 8 }}
                                />
                            )}
                        />
                    </Form.Item>
                </Col>

                <Col xs={24}>
                    <Form.Item
                        label={<strong>Confirmar Nova Senha</strong>}
                        required
                        validateStatus={errors.confirmPassword ? "error" : undefined}
                        help={errors.confirmPassword?.message}
                    >
                        <Controller
                            name="confirmPassword"
                            control={control}
                            rules={{
                                required: "Por favor, confirme a nova senha!",
                                minLength: {
                                    value: 8,
                                    message: "A senha precisa ter no mínimo 8 caracteres!",
                                },
                            }}
                            render={({ field }) => (
                                <Input.Password
                                    {...field}
                                    placeholder="Repita a nova senha para confirmação"
                                    prefix={<LockOutlined style={{ color: "#faad14" }} />}
                                    size="large"
                                    style={{ borderRadius: 8 }}
                                />
                            )}
                        />
                    </Form.Item>
                </Col>
            </Form>
        </Modal>
    );
}
